export const ryanairConditionLinksForNL = {
  termsAndConditions: 'https://help.ryanair.com/hc/nl/articles/12890911974289-Algemene-vervoersvoorwaarden',
  termsOfUse: 'https://www.ryanair.com/nl/nl/lp/kennisgeving-van-derden',
  privacyPolicy: 'https://www.ryanair.com/nl/nl/lp/privacybeleid',
  cookiePolicy: 'https://www.ryanair.com/nl/nl/cookie-policy/www_ryanair_com',
  notice: 'https://www.ryanair.com/nl/nl/lp/kennisgeving-van-derden',
}

export const ryanairConditionLinksForBENL = {
  termsAndConditions: 'https://help.ryanair.com/hc/nl-be/articles/12890911974289-Algemene-vervoersvoorwaarden',
  termsOfUse: 'https://www.ryanair.com/be/nl/zakelijk/gebruiksvoorwaarden',
  privacyPolicy: 'https://www.ryanair.com/be/nl/lp/privacybeleid',
  cookiePolicy: 'https://www.ryanair.com/be/nl/cookie-policy/www_ryanair_com',
  notice: 'https://www.ryanair.com/be/nl/lp/kennisgeving-van-derden',
}

export const ryanairConditionLinksForBEFR = {
  termsAndConditions: 'https://help.ryanair.com/hc/fr-be/articles/12890911974289-Conditions-g%C3%A9n%C3%A9rales-de-transport',
  termsOfUse: 'https://www.ryanair.com/be/fr/entreprise/termes-d-utilisation',
  privacyPolicy: 'https://www.ryanair.com/be/fr/lp/politique-de-confidentialite',
  cookiePolicy: 'https://www.ryanair.com/be/fr/cookie-policy/www_ryanair_com',
  notice: 'https://www.ryanair.com/be/fr/lp/avis-aux-tiers',
}

export const ryanairConditionLinksForSE = {
  termsAndConditions: 'https://help.ryanair.com/hc/sv/articles/12890911974289-Allm%C3%A4nna-villkor-och-transportvillkor',
  termsOfUse: 'https://www.ryanair.com/se/sv/foretag/anvandningsvillkor',
  privacyPolicy: 'https://www.ryanair.com/se/sv/lp/sekretesspolicy',
  cookiePolicy: 'https://www.ryanair.com/se/sv/cookie-policy/www_ryanair_com',
  notice: 'https://www.ryanair.com/se/sv/lp/meddelande-om-tredje-par',
}

export const ryanairConditionLinksForDK = {
  termsAndConditions: 'https://help.ryanair.com/hc/da/articles/12890911974289-Generelle-vilk%C3%A5r-og-betingelser-for-befordring',
  termsOfUse: 'https://www.ryanair.com/dk/da/virksomhed/brugervilkar',
  privacyPolicy: 'https://www.ryanair.com/dk/da/lp/fortrolighedspolitik',
  cookiePolicy: 'https://www.ryanair.com/dk/da/cookie-policy/www_ryanair_com',
  notice: 'https://www.ryanair.com/dk/da/lp/trejdepartsmeddelelse',
}

export const ryanairConditionLinksForFR = {
  termsAndConditions: 'https://help.ryanair.com/hc/fr-fr/articles/12890911974289-Conditions-g%C3%A9n%C3%A9rales-de-transport',
  termsOfUse: 'https://www.ryanair.com/fr/fr/entreprise/termes-d-utilisation',
  privacyPolicy: 'https://www.ryanair.com/fr/fr/lp/politique-de-confidentialite',
  cookiePolicy: 'https://www.ryanair.com/fr/fr/cookie-policy/www_ryanair_com',
  notice: 'https://www.ryanair.com/fr/fr/lp/avis-aux-tiers',
}

export const ryanairConditionLinksForEN = {
  termsAndConditions: 'https://help.ryanair.com/hc/en-gb/articles/12890911974289-General-Terms-Conditions-of-Carriage',
  termsOfUse: 'https://www.ryanair.com/gb/en/corporate/terms-of-use',
  privacyPolicy: 'https://www.ryanair.com/gb/en/lp/privacy-policy',
  cookiePolicy: 'https://www.ryanair.com/gb/en/cookie-policy/www_ryanair_com',
  notice: 'https://www.ryanair.com/gb/en/lp/third-party-notice',
}
